<template>
  <AntFormItem class="input">
    <label class="input__label heading" :for="name">{{ label }}</label>
    <AntInput
      :is="componentType"
      :class="customClass"
      :placeholder="placeholder"
      v-bind="$attrs"
      v-on="$listeners"
      v-decorator="[name, {
        rules: validationRules,
        validateTrigger: validateTrigger,
        validateFirst: true,
        preserve,
        initialValue,
      }]"
    />
  </AntFormItem>
</template>

<script>
import {
  Form as AntForm,
  Input as AntInput,
  InputNumber as AntInputNumber,
} from 'ant-design-vue';

import formFieldMixin from '@/common/mixins/form-field';

export default {
  name: 'Input',
  components: {
    AntInput: AntInput.Password,
    AntFormItem: AntForm.Item,
  },
  mixins: [formFieldMixin],
  props: {
    customClass: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    validationRules: {
      type: Array,
      default: () => [],
    },
    validateTrigger: {
      type: String,
      default: 'blur',
    },
    inputType: {
      type: String,
      default: 'text',
      validator: prop => ['text', 'password', 'number'].includes(prop),
    },
    initialValue: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    componentType() {
      const inputs = {
        number: AntInputNumber,
        password: AntInput.Password,
        default: AntInput,
      };
      return inputs[this.inputType] || inputs.default;
    },
  },
};
</script>

<style lang="scss">
  .input {
    &__label {
      font-size: 14px;
      font-weight: 600;
    }

    .ant-form-item-children {
      height: 100%;
    }

    .ant-input-affix-wrapper {
      height: 50px;
      margin-bottom: 5px;

      .ant-input {
        border-radius: 12px;
        border: 1px solid $grayLightest;
        font-size: 13px;
        font-weight: 500;
        letter-spacing: .3px;
        padding: 0 20px;

        &:hover {
          border-color: $accent;
        }

        &::placeholder {
          color: $gray;
          opacity: .41;
        }

        &.ant-input-disabled {
          background-color: rgba(229, 231, 239, .25);
          color: $secondary;
        }
      }
    }

    .has-error {
      .ant-input {
        border: 1px solid $red;
      }
    }

    .ant-form-explain {
      font-size: 12px;
      font-weight: 600;
      letter-spacing: .17px;
      color: $red;
    }

    .ant-input-number {
      align-items: center;
      border-radius: 12px;
      border: 1px solid $grayLightest;
      display: flex;
      font-size: 13px;
      font-weight: 500;
      height: 50px;
      letter-spacing: .3px;
      padding: 0 20px;
      width: 100%;

      &:hover {
        border-color: $accent;
      }

      &::placeholder {
        color: $gray;
        opacity: .41;
      }

      .ant-input-number-input {
        padding: 0;
      }

      .ant-input-number-handler-wrap {
        display: none;
      }

      .ant-input-number-input-wrap {
        width: 100%;
      }
    }
  }
</style>
